import { AccountInfo } from '@azure/msal-browser'

import { UserInfo } from './auth/authContext'
import { getCountryDefaultLocale, isValidLocale } from './locale'

export const getMsalUser = (user: AccountInfo): UserInfo => {
  return {
    identity: user.homeAccountId,
    username: user.username,
    userLocale: getMsalUserLocaleAndLanguage(user),
  }
}

const getLocale = (userLanguage: string, userCountryCode: string) => {
  if (userLanguage && userCountryCode) {
    const language = userLanguage.split(/[-_]/)[0].toLowerCase()
    const country = userCountryCode
      .substring(userCountryCode.length - 2)
      .toUpperCase()
    const userLocale = `${language === 'nb' ? 'no' : language}_${country}`
    if (isValidLocale(userLocale)) {
      return userLocale
    }
  }
  if (userCountryCode) {
    const userLocale = getCountryDefaultLocale(
      userCountryCode.substring(userCountryCode.length - 2),
    )
    if (userLocale) {
      return userLocale
    }
  }
  return 'en_IE'
}

const getMsalUserLocaleAndLanguage = (user: AccountInfo): string => {
  if (!user) return 'en_IE'

  const entity = user.idTokenClaims?.entity_id
  const language = user.idTokenClaims?.default_language
  const countryCode = typeof entity === 'string' ? entity : undefined
  const defaultLocale = typeof language === 'string' ? language : undefined

  return getLocale(defaultLocale, countryCode)
}
